import { Jodit } from 'jodit'

import { FeedbackMessengerWindowDraft } from '../draft/feedback-messenger-window-draft.component'
import { registerEditorApply } from '../draft/feedback-messenger-window-draft.editor-bridge'

import { feedbackMessengerWindowWysiwygSelector } from './feedback-messenger-window-wysiwyg.selectors'

const buttons = [
	'source',
	'|',
	'bold',
	'italic',
	'|',
	'ul',
	'ol',
	'eraser',
	'|',
	'font',
	'fontsize',
	'brush',
	'paragraph',
	'|',
	'image',
	'table',
	'link',
	'|',
	'align',
	'\n',
	'undo',
	'redo',
	'|',
	'hr',
	'copyformat',
	'fullsize',
]

const initializedMarkerAttribute = 'data-clm-wysiwyg-initialized'

const createWysiwyg = (element: HTMLElement) =>
	new Jodit(element, {
		cleanHTML: {
			removeEmptyElements: false,
		},
		enter: 'br',
		toolbarButtonSize: 'small',
		showCharsCounter: false,
		toolbarSticky: false,
		showWordsCounter: false,
		showXPathInStatusbar: false,
		buttons: [...buttons],
		toolbarAdaptive: false,
		askBeforePasteHTML: false,
		askBeforePasteFromWord: false,
		uploader: {
			insertImageAsBase64URI: true,
		},
	})

export const FeedbackMessengerWindowWysiwyg = (() => {
	const initWysiwyg = () => {
		const feedbackMessengerWindowWysiwygElement =
			feedbackMessengerWindowWysiwygSelector.getFeedbackMessengerWindowWysiwyg()

		if (
			feedbackMessengerWindowWysiwygElement === null ||
			feedbackMessengerWindowWysiwygElement.getAttribute(initializedMarkerAttribute) !== null
		) {
			return
		}
		feedbackMessengerWindowWysiwygElement.setAttribute(initializedMarkerAttribute, 'true')

		let wysiwygInstance: Jodit
		try {
			wysiwygInstance = createWysiwyg(feedbackMessengerWindowWysiwygElement)
		} catch (error) {
			// Clear the marker so a later init pass can retry, and keep the
			// remaining module inits alive.
			feedbackMessengerWindowWysiwygElement.removeAttribute(initializedMarkerAttribute)
			console.error(error)
			return
		}

		wysiwygInstance.e.on('change', () => {
			// Jodit does not reliably sync the source textarea while typing —
			// push the value so the draft (and a mid-typing submit) sees it.
			;(feedbackMessengerWindowWysiwygElement as HTMLTextAreaElement).value = wysiwygInstance.value
			FeedbackMessengerWindowDraft.debouncedSaveWindowDraft()
		})

		registerEditorApply((html) => {
			// The connected check drops writes aimed at an editor whose window
			// snippet has since been redrawn away.
			if (feedbackMessengerWindowWysiwygElement.isConnected) {
				wysiwygInstance.value = html
			}
		})
	}

	const initHandlers = () => {
		initWysiwyg()
	}

	const init = () => {
		initHandlers()
	}

	return {
		init,
	}
})()
